export default __webpack_public_path__ + "static/slider-image-2-b1847d77a4f44ae7cb80a3b88be63d0b.png";